import { render, staticRenderFns } from "./DashboardBarChart.vue?vue&type=template&id=461b2b78&scoped=true&"
import script from "./DashboardBarChart.vue?vue&type=script&lang=js&"
export * from "./DashboardBarChart.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBarChart.vue?vue&type=style&index=0&id=461b2b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461b2b78",
  null
  
)

export default component.exports